import { Dialog, Text, Flex } from "@fluentui/react-northstar";
import React from "react";
import { useTranslation } from "react-i18next";

import { useDesktopPermissionPromptStyles } from "./DesktopPermissionPrompt.styles";
import { DesktopPermissionPromptProps } from "./DesktopPermissionPrompt.types";

export const DesktopPermissionPrompt: React.FC<
  DesktopPermissionPromptProps
> = ({ isCamOrMicAccessDenied }) => {
  const permissionPromptStyles = useDesktopPermissionPromptStyles();
  const { t } = useTranslation();

  return (
    <Dialog
      data-testid="desktop-permission-prompt"
      open={isCamOrMicAccessDenied}
      styles={permissionPromptStyles.dialogBox}
      content={
        <Flex column gap="gap.medium" hAlign="center">
          <Text
            styles={permissionPromptStyles.header}
            as="h1"
            size="larger"
            weight="semibold"
            align="center"
            content={<>{t("ALLOW_PERMISSIONS_PROMPT_DESKTOP")}</>}
          />
          <Text
            styles={permissionPromptStyles.description}
            size="medium"
            weight="regular"
            align="center"
            content={<>{t("AFTER_PERMISSIONS_ALLOWED")}</>}
          />
        </Flex>
      }
      closeOnOutsideClick={true}
    />
  );
};
